import { render, staticRenderFns } from "./MensageriaScheduledList.vue?vue&type=template&id=19ee48bc&scoped=true"
import script from "./MensageriaScheduledList.vue?vue&type=script&lang=js"
export * from "./MensageriaScheduledList.vue?vue&type=script&lang=js"
import style0 from "./MensageriaScheduledList.vue?vue&type=style&index=0&id=19ee48bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19ee48bc",
  null
  
)

export default component.exports